import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const ArrowsCrossOutlinedSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("g", { children: jsx("path", { d: "M0.5 8L3.30709 5.19291L4.29704 6.18286L3.18006 7.29984H7.29984V3.18006L6.18266 4.29724L5.19271 3.30729L8 0.5L10.8071 3.30709L9.81714 4.29704L8.69984 3.17974V7.29984H12.8199L11.7028 6.18266L12.6927 5.19271L15.5 8L12.6927 10.8073L11.7028 9.81734L12.8203 8.69984H8.69984V12.8203L9.81714 11.703L10.8071 12.6929L8 15.5L5.19271 12.6927L6.18266 11.7028L7.29984 12.8199V8.69984H3.17974L4.29704 9.81714L3.30709 10.8071L0.5 8Z", fill: "var(--magritte-ui-icon-color)" }) }) }) }));
const ArrowsCrossOutlinedSize16 = hoc(forwardRef(ArrowsCrossOutlinedSize16Component), 'ArrowsCrossOutlinedSize16');

export { ArrowsCrossOutlinedSize16 as default };
//# sourceMappingURL=ArrowsCrossOutlinedSize16.js.map
